$(document).ready(function () {


    (function languageDropDownModule() {

        $('.language').on('click mouseover', function () {
            $('.language').addClass('opened');
        });


    })();

    $(document).on('click, mouseover', function (e) {
        var searched = 'language opened';

        if ($(e.target).hasClass(searched)) {
            return false;
        }

        var dropDown = $(e.target).parentsUntil('.language.opened').parent();
        if (dropDown.hasClass(searched)) {
            return false;
        }

        var menu = $('.language.opened');
        if (!menu.is(e.target) && menu.has(e.target).length === 0) {
            $('.language').removeClass('opened');
        }
    });

    (function () {
        //left-menu
        $('.left-content-menu .drop').click(function () {

            if ($(this).parent().hasClass('passive')) {
                var self = $(this);

                self.parent().siblings().slideDown('slow', function () {
                    self.parent().siblings().removeClass('active').addClass('passive');
                });

                self.parent().slideDown('slow', function () {
                    self.parent().addClass('active').removeClass('passive');
                });

                self.next('.submenu').slideUp('slow', function () {
                    self.next('.submenu').addClass('active').removeClass('passive');
                });

            } else if ($(this).parent().hasClass('active')) {

                $(this).siblings('.submenu').slideDown('slow', function () {
                    $(this).parent().removeClass('active').addClass('passive');
                });
            }
        });
    })();

    (function () {
        //$(window)
        //    .resize(function () {
        //        if ($(window).width() < 1000) {
        //            $('.menu-bg').css('display', 'none');
        //        } else {
        //            $('.menu-bg').css('display', 'block');
        //        }
        //    });

        $('.armada-nav-btn')
            .bind('click',
                function () {
                    if ($('.menu-bg').is(':hidden')) {
                        $('.menu-bg').slideDown('fast');
                    } else {
                        $('.menu-bg').slideUp('fast');
                    }
                });
    })();

    //add responsive class
    $('.main-page-icons').find('img').addClass('img-responsive');

    if (!$('.page-content').find('img').hasClass('img-responsive')) {
        $('.page-content').find('img').addClass('img-responsive');
    }

    //captcha handler before submit
    $('#imgCaptcha').attr('src', '/CaptchaHandler.ashx?query=' + Math.random());
    $('#btnCaptcha')
        .click(function () {
            $.ajax({
                cache: false,
                url: '/CaptchaHandler.ashx?query=' + Math.random(),
                success: function (data) {
                    $('#imgCaptcha').attr('src', '/CaptchaHandler.ashx?query=' + Math.random());
                },
                error: function (data, status, jqXHR) {
                    alert("HATA:" + status + ' KAYNAK: ' + jqXHR);
                }
            });
        });

    //search nav
    $('.btn-search')
        .click(function () {
            if ($('.content-search').is(':hidden')) {
                $('.content-search').slideDown(300);
            } else {
                $('.content-search').slideUp(300);
            }
        });

    equalheight = function (container) {
        var currentTallest = 0,
            currentRowStart = 0,
            rowDivs = new Array(),
            $el,
            topPosition = 0;
        $(container).each(function () {
            $el = $(this);
            $($el).outerHeight('auto');
            topPosition = $($el).position().top;
            if (currentRowStart != topPosition) {
                for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                    rowDivs[currentDiv].height(currentTallest);
                }
                rowDivs.length = 0; // empty the array
                currentRowStart = topPosition;
                currentTallest = $el.outerHeight();
                rowDivs.push($el);
            } else {
                rowDivs.push($el);
                currentTallest = (currentTallest < $el.outerHeight()) ? ($el.outerHeight()) : (currentTallest);
            }
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].outerHeight(currentTallest);
            }
        });
    }
    function setHEqualHeight() {
        if ($(window).width() > 0) {
            equalheight('.container-news-ebulten .column-news, .container-news-ebulten .column-sustainability');
            $('.sustainability-wrapper').css('height', $('.column-sustainability').height());
            //equalheight('.row-about .column-about, .row-about .column-image');


            //
            if ($(window).width() > 768) {
                $('.two-wrapper .one').css('height', $('.image-top-text-bottom .icon').height());
                //$('.two-wrapper .two').css('height', $('.image-top-text-bottom .text-section').height() - 15);

                $('.two-wrapper-2 .one').css('height', $('.image-top-text-bottom-2 .icon').height());
                //$('.two-wrapper-2 .two').css('height', $('.image-top-text-bottom-2 .text-section').height() - 15);
            }
            //equalheight('.referance-container .column-image:eq(0), .referance-container .column-image:eq(1)');
        }
    };
    var waitForFinalEvent = (function () {
        var timers = {};
        return function (callback, ms, uniqueId) {
            if (!uniqueId) {
                uniqueId = "Don't call this twice without a uniqueId";
            }
            if (timers[uniqueId]) {
                clearTimeout(timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
        };
    })();
    $(window).resize(function () {
        waitForFinalEvent(function () {
            setHEqualHeight();
        }, 500, "setHEqualHeightFn");
    });
    waitForFinalEvent(function () {
        setHEqualHeight();
    }, 500, "setHEqualHeightFn");
});

(function () {
    $('.scroll-arrow').click(function () {
        var offsetTop = $(window).height();

        //if ($(this).css('marginTop')) {
        //    offsetTop += parseFloat($(this).css('marginTop').replace('px', ''));
        //}
        //if ($('.slider-pager').length > 0) {
        //    offsetTop += parseFloat($('.slider-pager').css('height').replace('px', ''));
        //}

        $('html, body').animate({ scrollTop: offsetTop });
    });
})();

(function () {
    $('.load-more-section .load').click(function () {
        $('.slick-root-product-categories').find('.hidden').removeClass('hidden');
        $('.load-more-section .load').toggle();

        var $hiddenCategory = $('.slick-root-product-categories >div:nth-child(5)');
        if ($hiddenCategory.length > 0) {

            $('html, body').animate({ scrollTop: $hiddenCategory.offset().top });
        }
    });
})();

(function () {
    var $window = $(window);

    function checkIfInView(css, $animationElements) {
        var windowHeight = $window.height();
        var windowTopPosition = $window.scrollTop();
        var windowBottomPosition = (windowTopPosition + windowHeight);
        var transitionDelay = 0;
        $.each($animationElements, function () {

            var $element = $(this);
            var elementHeight = $element.outerHeight();
            var elementTopPosition = $element.offset().top;
            var elementBottomPosition = (elementTopPosition + elementHeight);
            transitionDelay += 0.2;

            //check to see if this current container is within viewport
            if ((elementBottomPosition >= windowTopPosition) &&
                (elementTopPosition <= windowBottomPosition)) {
                $element.css(css);
            }
        });
    }

    $window.on('scroll resize', function () {
        checkIfInView({
            transform: 'translate3d(0,0,0)',
            transition: 'all 1.2s cubic-bezier(.19,1,.22,1)',
            transitionDelay: '0.3s',
            opacity: 1.0
        }, $('.slick-referance'));
    });

    $window.trigger('scroll');

    (function reveal() {
        var reveals = document.querySelectorAll('.reveal');

        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 50;

            console.log(elementTop, windowHeight - elementVisible);

            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("active");
            } else {
                reveals[i].classList.remove("active");
            }
        }

        if (reveals) {
            window.addEventListener("scroll", reveal);
        }
    })();

})();

